import { baseSoundURL } from '../config';

export const resolveMediaUrl = (url: string | null | undefined): string | null => {
  if (!url) {
    return null;
  }
  if (
    /^https?:\/\//i.test(url) ||
    url.startsWith('//') ||
    url.startsWith('data:') ||
    url.startsWith('blob:')
  ) {
    return url;
  }
  const separator = url.startsWith('/') ? '' : '/';
  return `${baseSoundURL}${separator}${url}`;
};
